export type GateCheckoutInput = {
  /** School setting: require the customer to sign in before checkout. */
  requireLogin?: boolean;
  /** Whether the host app currently has a signed-in customer session. */
  isLoggedIn?: boolean;
  /**
   * The host-provided login callback. When absent the gate must NOT show —
   * a surface with no auth wired (e.g. webcomponents today) would otherwise
   * dead-end the customer with a non-functional button. This fail-open guard
   * is what makes the phased rollout safe.
   */
  onLogin?: (() => void) | undefined;
};

/**
 * Whether checkout should be blocked by the login gate.
 *
 * Gift cards are intentionally NOT considered here: gift-card checkout does not
 * route through the CheckoutOrchestrator at all (it has its own wrapper), so it
 * is exempt by construction and needs no flow-type check.
 */
export function shouldGateCheckout({
  requireLogin,
  isLoggedIn,
  onLogin,
}: GateCheckoutInput): boolean {
  return Boolean(requireLogin) && !isLoggedIn && typeof onLogin === "function";
}
